import type { CustomFormErrors, FormErrors } from 'redux-form';

import type { W_OrganizationCredential_Create_RM } from 'ab-api/web/organizationCredential/create';
import type { W_OrganizationCredential_FindOrganizationCredentials_VM_Row } from 'ab-api/web/organizationCredential/findAllForTable';

import { getId } from '@acceligentllc/shared/utils/array';

interface CompanyCredentialFM {
	id: number;
	label: string;
}

export class CreateOrganizationCredentialFM {
	name: string;
	companies: CompanyCredentialFM[];

	constructor() {
		this.name = '';
		this.companies = [];
	}

	static validate = (form: CreateOrganizationCredentialFM): FormErrors<CreateOrganizationCredentialFM> => {

		const errors: CustomFormErrors<CreateOrganizationCredentialFM> = {};

		if (!form.name) {
			errors.name = 'Name is required';
		}

		return errors as FormErrors<CreateOrganizationCredentialFM>;
	};

	static toRM(form: CreateOrganizationCredentialFM): W_OrganizationCredential_Create_RM {
		return {
			name: form.name,
			companyIds: form.companies.map(getId),
		};
	}

	static fromVM(vm: W_OrganizationCredential_FindOrganizationCredentials_VM_Row): CreateOrganizationCredentialFM {
		return {
			name: vm.name,
			companies: vm.companies.map((_company) => ({ id: _company.id, label: _company.name })),
		};
	}
}
